import { useRef } from 'react'
import { Box, HStack, Text } from '@chakra-ui/react'
import type { NextUpCardData } from '../mock-data'
import NextUpCard from './next-up-card'

interface INextUpScrollRowProps {
  cards: NextUpCardData[]
  rightMeta?: string
}

const CARD_NUDGE_PX = 316

const NextUpScrollRow = ({ cards, rightMeta }: INextUpScrollRowProps) => {
  const scrollRef = useRef<HTMLDivElement | null>(null)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const el = scrollRef.current
    if (!el) return
    if (e.key === 'ArrowRight') {
      e.preventDefault()
      el.scrollBy({ left: CARD_NUDGE_PX, behavior: 'smooth' })
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault()
      el.scrollBy({ left: -CARD_NUDGE_PX, behavior: 'smooth' })
    }
  }

  return (
    <Box>
      <HStack justify="space-between" align="baseline" mb="10px">
        <Text color="white" fontSize="16px" fontWeight={600} m={0}>
          Next Up
        </Text>
        {rightMeta && (
          <Text color="rgba(255,255,255,0.55)" fontSize="12px" m={0}>
            {rightMeta}
          </Text>
        )}
      </HStack>

      <HStack
        ref={scrollRef}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        align="stretch"
        spacing="16px"
        overflowX="auto"
        py={2}
        mx={-2}
        px={2}
        sx={{
          scrollSnapType: 'x mandatory',
          '::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
          outline: 'none'
        }}
        _focus={{ boxShadow: 'none' }}
        _focusVisible={{ boxShadow: 'none' }}
      >
        {cards.map(card => (
          <NextUpCard key={card.id} card={card} />
        ))}
      </HStack>
    </Box>
  )
}

export default NextUpScrollRow
